import { Header } from '../components/Header';
import { BottomNav } from '../components/BottomNav';
import { MessagesList } from '../components/messages/MessagesList';

/**
 * Dedicated Messages page. The actual list (filters + threads + states)
 * is rendered by the shared `MessagesList` component in `mode="full"` so
 * this page and the Profile → Messages tab stay 1:1 in sync.
 */
export const MessagesPage = () => {
  return (
    <div className="min-h-screen bg-cream pb-20 md:pb-0">
      <Header />
      <div className="max-w-4xl mx-auto p-6">
        <MessagesList mode="full" />
      </div>
      <BottomNav />
    </div>
  );
};
